import { BuilderContext } from '@ha/algolia';
import { GlobalState } from 'ha/types/store';
import { getFeatureFlags } from 'ha/modules/FeatureFlags';
import { getIsExcludingStudapartEnabled, getIsStudapartCitySearched } from '.';

interface SearchParams {
  city: string;
  countryCode: string;
}

export const getFilterBuilderContext = (
  state: GlobalState,
  queryType:
    | 'listings'
    | 'priceFacet'
    | 'propertyTypeFacet'
    | 'propertySizeFacet',
  searchParams?: SearchParams,
): BuilderContext => {
  // add experiments and feature flags regarding algolia query here

  const {
    withDynamicMinimumPrice,
    searchPartnerSorting,
    excludeMulFromSearch,
    withMoveInWindowFilter,
  } = getFeatureFlags(state);

  return {
    withoutPrice: queryType === 'priceFacet',
    withoutPropertyType: queryType === 'propertyTypeFacet',
    withDynamicMinimumPrice: withDynamicMinimumPrice === 'on',
    withoutPropertySize: queryType === 'propertySizeFacet',
    withPartnerSorting: searchPartnerSorting === 'on',
    withoutMultiUnits: excludeMulFromSearch === 'on',
    excludeStudapart:
      !!searchParams &&
      getIsStudapartCitySearched(searchParams) &&
      getIsExcludingStudapartEnabled(state),
    withMoveInWindowFilter: withMoveInWindowFilter === 'on',
  };
};
